import approveModal from "@/views/flow/approve/approveModal/index.vue";

export default {
    mixins: [],
    components: {
        approveModal
    },
    props: {},
    data () {
        return {
            showApproveModal: false,
            curApproveData: {
                _id: undefined, // 任务的_id
                step_inst: undefined,
                flow_inst: {},
                step_operate: undefined,
                step_def: {},
                flow: {},
                mod: {},
                data: {},
                subFlowDef: {}
            },
            approvePropsObj: undefined,

            dshRenderName: undefined
        };
    },
    computed: {
        dshRender () {
            return this[this.dshRenderName];
        }
    },
    methods: {
        // 打开审批模态框
        openApproveModal () {
            this.dshRenderName = "approveModalRender";
            this.showApproveModal = true;
        },
        // 关闭审批模态框
        closeApproveModal () {
            this.dshRenderName = undefined;
            this.showApproveModal = false;
        },
        // 切换审批模态框
        toggleApproveModal (bool) {
            this.showApproveModal = bool;
        },
        // 刷新的回调
        approveRefreshCb () {
            // 不需写代码，页面里需要会替换此方法
        },

        // 审批模态框渲染函数
        approveModalRender (h, params) {
            return this.showApproveModal
                ? h("approve-modal", {
                    props: {
                        value: this.showApproveModal,
                        companyId: this.companyId,
                        appId: this.appId,
                        appObj: this.appObj,
                        approveData: this.curApproveData,
                        propsObj: this.approvePropsObj
                    },
                    on: {
                        input: this.toggleApproveModal,
                        refresh: this.approveRefreshCb
                    }
                })
                : undefined;
        }
    }
};



// WEBPACK FOOTER //
// ./src/mixins/flow/approve/approveModalRenderMixin.js